import { Loader } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import "../../../assets/css/profilePage.css";

export const RequestedBox = () => {
  const { t } = useTranslation("profile");
  return (
    <div className="bRequestPending">
      <Loader color="#10B48F" />
      <div className="w-full">
        {/* <p
          style={{
            color: "#667085",
            fontWeight: "300",
            fontSize: "12px",
          }}
        >
          ล่าสุดเมื่อ
        </p> */}
        <p
          style={{
            color: "#2A2C2E",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          {t("pending")}
        </p>
      </div>
    </div>
  );
};
